import React from 'react';
import styled from 'styled-components';
import { useProjectElementListStore } from '../../shared/store/projectElementStore';
import { imHere } from '../../shared/component/Animation';
import orangeIcon from '../../asset/icon/orange.png';

export const PEIndicator: React.FC<{ peId: string; children: React.ReactNode }> = ({
  peId,
  children,
}) => {
  const hasChanged = useProjectElementListStore(
    (state) => state.projectElementList.find((pe) => pe.id === peId)?.hasChanged === true,
  );
  return (
    <PEIndicatorLabel>
      <PEIndicatorText>
        {children}
        {hasChanged && (
          <ChangedIconWrap>
            <ChangedIcon src={orangeIcon} alt="Unsaved changes" />
          </ChangedIconWrap>
        )}
      </PEIndicatorText>
    </PEIndicatorLabel>
  );
};

const PEIndicatorLabel = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  ${({ theme }) => theme.typography.Body_04};
`;

const PEIndicatorText = styled.span`
  position: relative;
  display: inline-block;
  color: ${({ theme }) => theme.colors.color_Gray_05};
`;

const ChangedIconWrap = styled.div`
  position: absolute;
  left: 100%;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  ${imHere}
`;

export default PEIndicator;

const ChangedIcon = styled.img`
  width: 12px;
  height: 12px;
  margin: 4px;
`;
